import { useMemo } from "react";
import { useTranslation } from "react-i18next"

export const useExpectedHoursConfig = () => {
    const { t } = useTranslation();
    
    return useMemo(() => [
        {
            key: "expectedHours",
            name: t("expected-hours")
        }
    ], [t]);
}
